export const firstSection = [
  {
    title: "Monthly Fee",
    flagField: "monthly_fee",
    valueField: "monthly_fee_default",
    type: "amount",
  },
  {
    title: "Per Transaction",
    flagField: "per_transaction",
    valueField: "per_transaction_default",
    type: "amount",
  },
  {
    title: "Purchase For",
    flagField: "purchase_for",
    valueField: "purchase_for_default",
    type: "amount",
  },
  {
    title: "Rent For",
    flagField: "rent_for",
    valueField: "rent_for_default",
    type: "amount",
  },
  {
    title: "Monthly Wireless",
    flagField: "monthly_wireless",
    valueField: "monthly_wireless_default",
    type: "amount",
  },
  {
    title: "Sass Fee",
    flagField: "sass_fee",
    valueField: "sass_fee_default",
    type: "amount",
  },
  {
    title: "Lease For",
    flagField: "lease_for",
    valueField: "lease_for_default",
    type: "amount",
  },
  {
    title: "Amount",
    flagField: "amount",
    valueField: "amount_default",
    type: "amount",
  },
  {
    title: "Factor Rate",
    flagField: "factor_rate",
    valueField: "factor_rate_default",
    type: "amount",
  },
  {
    title: "Payback",
    flagField: "payback",
    valueField: "payback_default",
    type: "amount",
  },
  {
    title: "SIM Card",
    flagField: "sim_card",
    valueField: "sim_card_monthly_default",
    type: "amount",
  },
  {
    title: "Text/SMS Fee",
    flagField: "text_sms_fee",
    valueField: "text_sms_fee_default",
    type: "amount",
  },
  {
    title: "Monthly Cellular Transaction",
    flagField: "monthly_cellular_txn",
    valueField: "monthly_cellular_txn_default",
    type: "amount",
  },
  {
    title: "Cellular Per Transaction",
    flagField: "cellular_per_txn",
    valueField: "cellular_per_txn_default",
    type: "amount",
  },
];

export const secondSection = [
  {
    title: "Hardware Default",
    flagField: "hardware",
    valueField: "hardware_default",
    type: "equipmentIdString",
  },
  {
    title: "File Types Default",
    flagField: "file_types",
    valueField: "file_types_default",
    type: "optionString",
  },
  {
    title: "Package Default",
    flagField: "package",
    valueField: "package_default",
    type: "optionString",
  },
  {
    title: "Other Equipments Default",
    flagField: "other_equipments",
    valueField: "other_equipments_default",
    type: "equipmentIdString",
  },
  {
    title: "Cable Length Default",
    flagField: "cable_length",
    valueField: "cable_length_default",
    type: "optionString",
  },
  {
    title: "Connectivity",
    flagField: "connectivity",
    valueField: "connectivity_options",
    type: "optionString",
    hideOnEquipmentForm: true,
  },
  {
    title: "Connectivity Default",
    flagField: "connectivity",
    valueField: "connectivity_default",
    type: "optionString",
  },
  {
    title: "Pin Pad Name Default",
    flagField: "pin_pad",
    valueField: "pin_pad_name_default",
    type: "string",
  },
  {
    title: "Add On Equipment",
    flagField: "add_on_equipment",
    valueField: "add_on_equipment_options",
    type: "equipmentIdArrayString",
  },
  {
    title: "Nuvie Equipment Name",
    flagField: "equipment_for_nuvie",
    valueField: "nuvie_equipment_name",
    type: "string",
  },
  {
    title: "Promotion Text",
    flagField: "promotion_text",
    valueField: "promotion_text",
    type: "string",
    hideOnEquipmentForm: true,
  },
];

export const thirdSection = [
  {
    title: "Customer Facing",
    flagField: "customer_facing",
    valueField: "customer_facing",
    type: "boolean",
  },
  {
    title: "Apply TPP",
    flagField: "apply_tpp",
    valueField: "apply_tpp_default",
    type: "boolean",
  },
  {
    title: "Virtual Terminal",
    flagField: "virtual_terminal",
    valueField: "virtual_terminal",
    type: "boolean",
  },
  {
    title: "PIN Debit",
    flagField: "pin_debit",
    valueField: "pin_debit",
    type: "boolean",
  },
];
